import { Quote } from "lucide-react";

const items = [
  {
    quote:
      "Keepsy rebuilt my LinkedIn in a week and I had three discovery calls booked from inbound DMs by day twelve. Every business needs a bookkeeper — they just made mine the obvious choice.",
    name: "David Whitcombe",
    title: "Founder, Whitcombe Books",
    img: "https://images.unsplash.com/photo-1772301685774-a4f0e81e032e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBhY2NvdW50YW50JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc4Njg2OTE3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "I used to dread LinkedIn. Now it's our number one source of clients. The profile overhaul alone paid for itself in the first month — and the DM conversations actually sound like me.",
    name: "Maria Park",
    title: "Partner, Northbar Advisory",
    img: "https://images.unsplash.com/photo-1760351561005-718d0e766dac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBhY2NvdW50YW50JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc4Njg2OTE3fDA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Testimonials() {
  return (
    <section
      id="proof"
      data-testid="testimonials-section"
      className="py-20 lg:py-28 bg-[#09090B] text-white border-b border-[#09090B]"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-[#3FA742] mb-4">
              Proof
            </p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05] text-white">
              Bookkeepers don't write reviews.<br />These ones did.
            </h2>
          </div>
          <p className="text-white/60 max-w-xs text-sm">
            Two of the 30+ firms now using LinkedIn as their #1 client source — with Keepsy running it for them.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {items.map((it, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#09090B] p-10 lg:p-12 relative"
            >
              <Quote size={28} className="text-[#3FA742] mb-6" strokeWidth={1.5} />
              <blockquote className="font-display font-medium text-xl lg:text-2xl leading-snug tracking-tight text-white">
                "{it.quote}"
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10 flex items-center gap-4">
                <img
                  src={it.img}
                  alt={it.name}
                  className="w-12 h-12 object-cover grayscale border border-white/20"
                  loading="lazy"
                />
                <div>
                  <p className="font-display font-bold text-base text-white">{it.name}</p>
                  <p className="text-xs text-white/60 font-mono uppercase tracking-widest mt-1">{it.title}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
